// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__2IitX","title":"ClientReferral_title__1FIhJ","itemText":"ClientReferral_itemText__ZwQuO"};